import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { AngularFirestore } from '@angular/fire/firestore';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ImageService {

  imageDetailList: AngularFireList<any[]>;

  constructor(private fb: AngularFireDatabase, private database: AngularFireDatabase, private firestore: AngularFirestore, private http: HttpClient) {
    this.imageDetailList = database.list('/imageDetails');
  }

  getImageDetails() {
    return this.firestore.collection("imageDetails").snapshotChanges();
  }

  insertImageDetails(imageDetails: any) {
    /*console.log(imageDetails);
    this.imageDetailList.push(imageDetails);*

    return new Promise<any>((resolve, reject) => {
      this.firestore.collection("imageDetails").add(imageDetails).then(res => { }, err => reject(err));
    });*/

    return this.firestore.collection('imageDetails').add(imageDetails);

  }

  deleteAdventure(id: string) {
    // this.firestore.doc('imageDetails/' + id).delete();
    return this.firestore.collection("imageDetails").doc(id).delete();
  }

}
